module.exports = __webpack_public_path__ + "img/icon-deposit-complete2.91b1c557.svg";